/* eslint-disable no-cond-assign */
/* eslint-disable no-bitwise */
import complement from 'ramda/src/complement';
import isEmpty from 'ramda/src/isEmpty';

const isNotEmpty = complement(isEmpty);

const validateExpDateInput = (value) => {
    const currentYear = new Date().getFullYear().toString().slice(2);
    const currentMonth = new Date().getMonth().toString();

    const [expMonth, expYear] = value.split('/');

    if (+expYear > +currentYear) {
        return true;
    }
    if (+expYear === +currentYear && +expMonth >= +currentMonth + 1) {
        return true;
    }

    return false;
};

const changeDateFormat = (date: string) => {
    const [year, month, day] = date.split('-');

    return new Date(+year, +month - 1, +day).toLocaleString('ru', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
    });
};

const getIsAndroid = () => {
    if (/Android/i.test(navigator.userAgent)) {
        return true;
    }

    return false;
};

export { complement, isEmpty, isNotEmpty, validateExpDateInput, changeDateFormat, getIsAndroid };
